module.exports = __webpack_public_path__ + "static/media/4.927bd54c.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row3/4.wav
// module id = 71
// module chunks = 0